import React, { FC } from 'react';
import { TemplateItem } from './TemplateItem';
import css from './TemplatesGrid.scss';
import classNames from 'classnames';
import { DataHooks } from '../../../constants/dataHooks';
import { AppTemplate } from '@wix/ambassador-devcenter-apps-v1-app-template/types';

export type OnTemplateClickFunc = (template: AppTemplate) => void;

type Props = {
  templates: AppTemplate[];
  onTemplateClick: OnTemplateClickFunc;
};

export const TemplatesGrid: FC<Props> = ({ templates, onTemplateClick }) => (
  <div
    data-hook={DataHooks.TemplatesGridWrapper}
    className={classNames(css.templatesGridWrapper, {
      [css.templatesGridWrapperWide]: templates.length > 2,
    })}
  >
    {templates.map((template, index) => (
      <TemplateItem
        template={template}
        index={index}
        onTemplateClick={onTemplateClick}
      />
    ))}
  </div>
);
